import Toastify from 'toastify-js'

const showToastify = (message, opts) => {
	Toastify({
		duration: 3000,
		position: "center",
		style: { background: "linear-gradient(to right, rgb(var(--alert-success)), rgb(var(--alert-success))" },
		text: message,
		...opts
	}).showToast();
}

export default showToastify